import * as _ from 'lodash'
import React from 'react';
import * as actions from '../actions';
import componentServices from '../componentServices';
import valueFilters from '../valueFilters';
import productFactory from '../models/productModel';
import { Confirm, CurrencyInput, Popup } from './sharedComponents';

class ProductRow extends React.Component<any,any> {
	private _renderedProduct;

	constructor (props) {
		super(props);

		this.state = { shouldValidate: props.alwaysValidate };

		this.handleButtonClick = this.handleButtonClick.bind(this);
		this.updateModel = this.updateModel.bind(this);
	}

	shouldComponentUpdate (nextProps) {
		let result = false;
		if (!this._renderedProduct) {
			result = true;
			this._renderedProduct = productFactory(nextProps.product);
		}
		else {
			result = !!this._renderedProduct.getPatch(nextProps.product).length;
		}
		return result;
	}

	updateModel (path, autoSave, e) {
		const newVal = (autoSave) ? valueFilters.clean(e.target.value) : e.target.value;

		this.props.updateModel(model => {
			model.setAt(path, newVal);
		}, { autoSave: autoSave });
	}

	validate (property?) {
		if (!property || this.state.shouldValidate) {
			const result = !this.props.product.test(property);

			return result;
		}
		return true;
	}

	handleButtonClick (e) {
		e.preventDefault();

		const valid = this.validate();

		if (!valid) {
			this.setState({ shouldValidate: true });
		}
		else {
			// this assumes that the add handler succeeds
			this.setState({ shouldValidate: this.props.alwaysValidate });
		}

		this.props.buttonHandler(valid, e);
	}

	render () {
		const { classNames = [], buttonClass, product } = this.props;

		return 	(<tr className={classNames.join(' ')}>
			<td />
			<td className={ this.validate('sku') ? '' : 'required' }><input type="text" placeholder="Enter" autoCapitalize="" autoCorrect="off" value={ product.viewValue('sku') } onChange={ this.updateModel.bind(this, 'sku', false) } onBlur={ this.updateModel.bind(this, 'sku', true) } /></td>
			<td className={ this.validate('name') ? '' : 'required' }><input type="text" placeholder="Enter" autoCapitalize="" autoCorrect="off" value={ product.viewValue('name') } onChange={ this.updateModel.bind(this, 'name', false) } onBlur={ this.updateModel.bind(this, 'name', true) } /></td>
			<td className={ this.validate('cost') ? 'cost' : 'cost required' }><CurrencyInput placeholder="0.00" value={ product.viewValue('cost') } onChange={ this.updateModel.bind(this, 'cost', false) } onBlur={ this.updateModel.bind(this, 'cost', true) } /></td>
			<td><button className={ buttonClass } onClick={ this.handleButtonClick }><span /></button></td>
			<td />
		</tr>);
	}
}

export default class VendorProducts extends React.Component<any,any> {
	constructor (props) {
		super(props);

		this.state = this.getStateFromProps(props);
	}

	getStateFromProps (props) {
		const state = _.assign({}, this.state);

		if (!state.pendingProduct || state.pendingProduct.type !== props.type) {
			state.pendingProduct = this.createPendingLineItem(props);
		}

		return state;
	}

	addLineItemHandler (productKey, isValid) {
		const securityContext = componentServices.securityContext;
		const currentModule = componentServices.routeParams.modulekey;
		const readOnly = !securityContext.currentUserHasFeature(currentModule, 'supplier-basic');

		if (!isValid || readOnly) {
			return;
		}

		this.props.updateModel(vendor => {
			if (productKey === this.state.pendingProduct.key) {
				vendor.products.add(this.state.pendingProduct);

				this.setState({ pendingProduct: this.createPendingLineItem(this.props) });
			}
		}, { autoSave: true });
	}

	contextMenuHandler (product, isValid, e) {
		const securityContext = componentServices.securityContext;
		const currentModule = componentServices.routeParams.modulekey;
		const readOnly = !securityContext.currentUserHasFeature(currentModule, 'supplier-basic');

		if (readOnly) { return; }

		const doDelete = () => {
			this.props.updateModel(vendor => {
				vendor.products.delete(product.key);
			}, { autoSave: true });

			setTimeout(actions.popModal, 0);
		};

		const confirmDelete = () => {
			const confirm = <Confirm title={ `Permanently Delete ${product.sku}?` } message={ 'Are you sure you want to permanently delete this product? This cannot be undone.' } confirmLabel="Permanently Delete" cancelLabel="Cancel" cancelHandler={ actions.popModal } confirmHandler={ doDelete } />;

			actions.popModal();
			actions.pushModal({ component: confirm });
		};

		const popup = (<Popup target={e.target}><div className="content scrollable">
			<ul className="menu">
				<li><a className="button icon iconLabel removeItem delete" onClick={ confirmDelete }><span>Delete</span></a></li>
			</ul>
		</div></Popup>);

		actions.pushModal({ component: popup });
	}

	createPendingLineItem (props) {
		const { vendor } = props;
		return productFactory({ vendorKey: vendor.key });
	}

	updateModel (key, updater, options) {
		const securityContext = componentServices.securityContext;
		const currentModule = componentServices.routeParams.modulekey;
		const readOnly = !securityContext.currentUserHasFeature(currentModule, 'supplier-basic');

		if (readOnly) { return; }

		this.props.updateModel(vendor => {
			let product = vendor.products.get(key);

			if ((!product) && (key === this.state.pendingProduct.key)) {
				product = this.state.pendingProduct;
				options.autoSave = false;
			}

			if (product) {
				updater(product);
			}
		}, options);
	}

	render () {
		const { vendor } = this.props;
		const securityContext = componentServices.securityContext;
		const currentModule = componentServices.routeParams.modulekey;
		const readOnly = !securityContext.currentUserHasFeature(currentModule, 'supplier-basic');

		const rows = _.map(_.sortBy(vendor.products, 'sku'), product => {
			return (
				<ProductRow key={product.key} updateModel={ this.updateModel.bind(this, product.key) } buttonHandler={ this.contextMenuHandler.bind(this, product) } product={product} classNames={ ['added', 'dropTarget']} buttonClass="icon iconOnly contextMenu" alwaysValidate={ true } />
			);
		});

		return (
			<section className="expander expanded">
				<div className={ readOnly ? 'inner readOnly' : 'inner'}>

					<table className="compact" cellPadding="0" cellSpacing="0">
						<thead>
							<tr>
								<td />
								<td><span className="readOnly">SKU</span></td>
								<td className=""><span className="readOnly">Name</span></td>
								<td className="cost"><span className="readOnly">Cost</span></td>
								<td className="action" />
								<td />
							</tr>
						</thead>
						<tbody>
							<ProductRow key={this.state.pendingProduct.key} updateModel={this.updateModel.bind(this, this.state.pendingProduct.key)} buttonHandler={this.addLineItemHandler.bind(this, this.state.pendingProduct.key)} product={this.state.pendingProduct} classNames={ ['addRow'] } buttonClass="icon iconOnly addItem" />
							{ rows }
						</tbody>
					</table>
				</div>
			</section>
		);
	}
}
